export const formatDate = (date) => {
    const dateObj = new Date(date);
    // if NaN return empty string
    if (isNaN(dateObj.getTime())) return '';
    return dateObj.getDate() + '/' + (dateObj.getMonth() + 1) + '/' + dateObj.getFullYear();
}